import { t } from "i18next";
import type { NavigateFunction } from "react-router-dom";
import { Eye } from "lucide-react";

import { RowActionsMenu } from "@/core/components/shared/data-table";
import type { SavingsVaultRow } from "@/features/savings/components/vaults/savings-vaults-columns";

/**
 * Menu d'actions de ligne d'un coffre : voir le détail. Aucune mutation au
 * simple clic (règle projet) — les actions financières vivent sur la page
 * de détail, chacune derrière une preview de confirmation.
 */
export function SavingsVaultRowActions({
  vault,
  navigate,
}: {
  vault: SavingsVaultRow;
  /** Fourni par la fabrique de colonnes de `DataTableClar`. */
  navigate: NavigateFunction;
}) {
  return (
    <RowActionsMenu
      actions={[
        {
          id: "view",
          label: t("savings.vaults.actions.view"),
          icon: Eye,
          onClick: () => navigate(`/app/wallet/savings-vaults/${vault.id}`),
        },
      ]}
    />
  );
}
